/**
 * Regla de disponibilidad del modo "Envío" en el checkout del micrositio.
 *
 * Función pura (Fase 1b T11) — nada de fetch ni de estado acá. El modo "ship"
 * existe solo si: el flag del local está encendido, el pedido NO es de mesa
 * (un cliente sentado por QR no manda su comida por paquetería), y TODO el
 * carrito es shippable (I12: un carrito mixto QSR+cajas no pasa a "ship" —
 * mezclarlos dejaría el pedido sin un modo de cumplimiento coherente).
 */
export function shipModeAvailable(args: {
  shippingEnabled: boolean
  tableContext: boolean
  cartItemIds: string[]
  shippableItemIds: ReadonlySet<string>
}): boolean {
  if (!args.shippingEnabled || args.tableContext) return false
  if (args.cartItemIds.length === 0) return false
  return args.cartItemIds.every((id) => args.shippableItemIds.has(id))
}
